import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var Fuel = createSvgIcon(React__default.createElement("path", { d: "M6.00049 4L16.0005 4L16.0005 20L6.00049 20L6.00049 4ZM4.00049 2L6.00049 2L16.0005 2L18.0005 2V4L18.0005 17H18.5L18.5 8V7.58579L18.7929 7.29289L19.7929 6.29289L21.2071 7.70711L20.5 8.41421L20.5 18V19H19.5H18.0005V20V22H16.0005L6.00049 22H4.00049V20L4.00049 4V2ZM8 6L14 6L14 10L8 10L8 6ZM12.6584 15.3167L11 12L9.34164 15.3167C8.72524 16.5495 9.62169 18 11 18C12.3783 18 13.2748 16.5495 12.6584 15.3167Z", fillRule: "evenodd" }), 'Fuel');

export { Fuel };
